module.exports = __webpack_public_path__ + "static/media/smartAsn-logo.95f2d495.svg";